import React from 'react';
import { Bone, Card, Row, Col, Container } from './SkeletonPulse';

const BadgeRow = ({ isLast }) => (
  <>
    <Row gap={14} style={{ padding: '14px 18px' }}>
      <Bone circle height={52} />
      <Col gap={6} style={{ flex: 1 }}>
        <Bone width="60%" height={14} />
        <Bone width="85%" height={11} />
      </Col>
      <Bone circle height={22} />
    </Row>
    {!isLast && (
      <div
        style={{
          height: 1,
          background: 'var(--c-border, #e0ddd6)',
          margin: '0 18px 0 84px',
        }}
      />
    )}
  </>
);

const AchievementsSkeleton = () => (
  <Container style={{ paddingTop: 12, paddingBottom: 40 }}>
    {/* Summary pill */}
    <div style={{ textAlign: 'center', padding: '8px 0 16px' }}>
      <Bone width={100} height={14} style={{ margin: '0 auto' }} />
    </div>

    {/* Badges list card */}
    <Card style={{ padding: 0, overflow: 'hidden' }}>
      <BadgeRow />
      <BadgeRow />
      <BadgeRow />
      <BadgeRow />
      <BadgeRow isLast />
    </Card>
  </Container>
);

export default AchievementsSkeleton;
